import * as ReduxUtils from "../../lib/util/ReduxUtils";
import * as StorageUtils from "../../lib/util/StorageUtils";
import * as GroupActions from "./Groups.action";

import { Action } from "../../lib/util/ReduxUtils";
import { SELECTED_GROUP_KEY } from "../../StorageKeys";

export interface GroupsReducerState {
	selectedGroup: string | undefined;
	rootGroupId: string | undefined;
}

const initialState: GroupsReducerState = {
	selectedGroup: undefined,
	rootGroupId: undefined,
};

const updateGroup = (
	state: GroupsReducerState,
	action: Action<any>,
): GroupsReducerState => {
	const { group, rootGroupId } = action.payload;
	StorageUtils.set(SELECTED_GROUP_KEY, group);
	return { ...state, selectedGroup: group, rootGroupId };
};

export default ReduxUtils.composeReducer(
	initialState,
	(initialState) => ({
		...initialState,
		selectedGroup: StorageUtils.get(SELECTED_GROUP_KEY),
	}),
	[
		ReduxUtils.createReducerMap({
			[GroupActions.changeScopeGroup.type]: updateGroup,
			[GroupActions.setScopeGroup.type]: updateGroup,
		}),
	],
);
